const queryString = require('query-string')
const SCOPES = ['snsapi_base', 'snsapi_userinfo']
import global from './global'
class VueWechatAuthPlugin {
	install(Vue) {
		let wechatAuth = this
		Vue.mixin({
			created: function() {
				this.$wechatAuth = wechatAuth
			}
		})
	}
	constructor() {
		this.redirect_uri = null
		this.scope = SCOPES[1]
		this._code = null
		this._redirect_uri = null
	}

	static makeState() {
		return Math.random().toString(36).substring(2, 15) + Math.random().toString(36).substring(2, 15)
	}


	set redirect_uri(redirect_uri) {
		this._redirect_uri = encodeURIComponent(redirect_uri)
	}

	get redirect_uri() {
		return this._redirect_uri
	}

	get state() {
		return localStorage.getItem("wechat_auth:state")
	}

	set state(state) {
		localStorage.setItem("wechat_auth:state", state)
	}

	get authUrl() {
		if (this.redirect_uri === null) {
			throw "redirect uri must not be null"
		}
		this.state = VueWechatAuthPlugin.makeState()
		return `https://open.weixin.qq.com/connect/oauth2/authorize?appid=${global.wxAppId}&redirect_uri=${this.redirect_uri}&response_type=code&scope=${this.scope}&state=${this.state}#wechat_redirect`
	}

	returnFromWechat(redirect_uri) {
		let parsedUrl = queryString.parse(redirect_uri.split('?')[1])
		this.state = null
		this._code = parsedUrl.code
    console.log(this._code)
	}

	get code() {
		if (this._code === null) {
			throw "Not get the code from wechat server!"
		}
		let code = this._code
		this._code = null
		return code
	}
}

const vueWechatAuthPlugin = new VueWechatAuthPlugin()
export default vueWechatAuthPlugin
